(function () {
  if (typeof IntersectionObserver === 'undefined') return;

  /* Balanced mix of left/right/up/dissolve/pop directions */
  var variants = ['panda-var-left', 'panda-var-up', 'panda-var-right', 'panda-var-dissolve',
                  'panda-var-up', 'panda-var-pop', 'panda-var-right', 'panda-var-left',
                  'panda-var-up', 'panda-var-dissolve', 'panda-var-left', 'panda-var-pop'];
  var varIdx = 0;

  var targets = [
    '.shopify-section h2',
    '.shopify-section h3',
    '.multicolumn-list__item',
    '.card-wrapper',
    '.pst-card',
    '.panda-reveal',
    '.rich-text__blocks',
    '.shopify-section .rte > p',
    '.footer-block'
  ].join(',');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('panda-revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -20px 0px' });

  function init() {
    var toObserve = [];

    document.querySelectorAll(targets).forEach(function (el) {
      /* Skip custom animated sections */
      if (el.closest('.pss') || el.closest('.ptc')) return;
      /* Skip ALL accordion / collapsible / FAQ elements */
      if (el.closest('details') || el.closest('.collapsible-content') || el.closest('.pfaq')) return;
      /* Skip marquee band (already animating) */
      if (el.closest('.pmb')) return;
      /* Limit to first 60 elements to avoid overwhelming the page */
      if (toObserve.length >= 60) return;

      var v = variants[varIdx % variants.length];
      varIdx++;
      el.classList.add('panda-pre-reveal', v);
      toObserve.push(el);
    });

    /* Double rAF: ensures opacity:0 is painted BEFORE observation starts so
       elements already in viewport still animate (not skipped on first tick) */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toObserve.forEach(function (el) { observer.observe(el); });
      });
    });

    /* Intercept #contact links to open modal instead of navigating */
    document.querySelectorAll('a[href="#contact"], a[href*="pages/contact"]').forEach(function (a) {
      if (a.classList.contains('panda-modal-trigger-skip')) return;
      if (a.closest('.pcm')) return;
      if (a.closest('.header__icons')) return;
      a.addEventListener('click', function (e) {
        if (typeof pandaModalOpen === 'function') {
          e.preventDefault();
          pandaModalOpen();
        }
      });
    });

    initPtcTiles();
    initWspaCarousel();
    fixDetailBtn();
    insertWhiteGap();
  }

  function initPtcTiles() {
    /* Shake on hover */
    document.querySelectorAll('.ptc-card').forEach(function(card) {
      if (card._pandaPtcShake) return;
      card._pandaPtcShake = true;
      card.addEventListener('mouseenter', function() {
        card.classList.remove('ptc-card--shake');
        void card.offsetWidth;
        card.classList.add('ptc-card--shake');
      });
      card.addEventListener('animationend', function(e) {
        if (e.animationName === 'ptcShake') card.classList.remove('ptc-card--shake');
      });
    });
  }

  function insertWhiteGap() {
    var anchor = document.querySelector('#shopify-section-featured_detailing');
    if (!anchor || anchor._pandaGap) return;
    anchor._pandaGap = true;
    var gap = document.createElement('div');
    gap.setAttribute('style',
      'background:#ffffff;height:320px;width:100%;display:block;' +
      'position:relative;z-index:1;flex-shrink:0;');
    anchor.parentNode.insertBefore(gap, anchor.nextSibling);
  }

  function fixDetailBtn() {
    /* Target the See All Detailing button by its exact href — most specific possible */
    var btns = document.querySelectorAll(
      'a[href="/pages/detailing"].button, a[href="/pages/detailing"].button--primary, ' +
      '#shopify-section-featured_detailing a[href="/pages/detailing"], ' +
      '#shopify-section-featured_detailing .button--primary'
    );
    if (btns.length === 0) return;
    btns.forEach(function (btn) {
      if (btn._pandaFixed) return;
      btn._pandaFixed = true;
      var p = btn.style.setProperty.bind(btn.style);
      function applyDefault() {
        p('background-color', 'transparent', 'important');
        p('background', 'transparent', 'important');
        p('color', '#f5c518', 'important');
        p('border', '2px solid #f5c518', 'important');
        p('border-radius', '4px', 'important');
        p('padding', '12px 22px', 'important');
        p('font-size', '1.5rem', 'important');
        p('font-weight', '800', 'important');
        p('letter-spacing', '0.1em', 'important');
        p('text-transform', 'uppercase', 'important');
        p('text-decoration', 'none', 'important');
        p('cursor', 'pointer', 'important');
        p('display', 'inline-flex', 'important');
      }
      applyDefault();
      btn.addEventListener('mouseenter', function () {
        p('background-color', '#f5c518', 'important');
        p('background', '#f5c518', 'important');
        p('color', '#111d2b', 'important');
        p('transform', 'translateY(-2px) scale(1.04)', 'important');
        p('box-shadow', '0 6px 20px rgba(245,197,24,0.4)', 'important');
      });
      btn.addEventListener('mouseleave', function () {
        applyDefault();
        p('transform', 'none', 'important');
        p('box-shadow', 'none', 'important');
      });
    });
  }

  /* Run fixDetailBtn at multiple points to beat any Dawn post-render JS */
  window.addEventListener('load', fixDetailBtn);
  setTimeout(fixDetailBtn, 800);

  function initWspaCarousel() {
    var section = document.querySelector('#shopify-section-what_sets_apart');
    if (!section) return;
    var items = Array.from(section.querySelectorAll('.multicolumn-list__item'));
    if (items.length === 0) return;
    var idx = 0;
    function tick() {
      items.forEach(function (el) { el.classList.remove('wspa-active'); });
      items[idx].classList.add('wspa-active');
      idx = (idx + 1) % items.length;
    }
    tick();
    setInterval(tick, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
